import type { SVGProps } from "react";

export const Check = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_15308_168)">
      <path d="M8.33336 12.6434L15.9934 4.98254L17.1725 6.16088L8.33336 15L3.03003 9.69671L4.20836 8.51838L8.33336 12.6434Z" />
    </g>
    <defs>
      <clipPath id="clip0_15308_168">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
